module.exports = __webpack_public_path__ + "static/media/23.c82648bc.mp3";